export enum SystemContactVisibility {
  SendMessages = 1,
  ReadOnly = 2,
}
